var render = function () {
  var _vm$userData, _vm$userData2, _vm$userData2$user, _vm$userData2$user$da, _vm$userData3, _vm$userData3$user, _vm$userData3$user$da, _vm$userData4, _vm$userData4$user, _vm$userData4$user$da, _vm$userData5, _vm$userData5$user, _vm$userData5$user$da, _vm$userData6, _vm$userData6$user, _vm$userData6$user$da, _vm$userData7, _vm$userData7$user, _vm$userData7$user$da, _vm$userData8, _vm$userData8$user, _vm$userData8$user$da, _vm$userData8$user$da2, _vm$userData9, _vm$userData9$user, _vm$userData9$user$da, _vm$userData9$user$da2, _vm$userData10, _vm$userData11, _vm$userData11$user, _vm$userData11$user$d, _vm$userData12, _vm$userData12$user, _vm$userData12$user$d, _vm$userData13, _vm$userData13$user, _vm$userData13$user$d, _vm$userData14, _vm$userData14$user, _vm$userData14$user$d, _vm$userData15, _vm$userData15$user, _vm$userData15$user$d, _vm$userData16, _vm$userData16$user, _vm$userData16$user$d, _vm$userData17, _vm$userData17$user, _vm$userData17$user$d, _vm$userData17$user$d2, _vm$userData18, _vm$userData18$user, _vm$userData18$user$d, _vm$userData18$user$d2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$permissionAbility(_vm.VISIT_ATTENDANCE_SHOW_ALL, _vm.permissions) ? [_c('b-card-actions', {
    attrs: {
      "title": "Filters",
      "action-collapse": ""
    }
  }, [_c('div', [_c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.filterEmpIdOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Select Employee"
    },
    on: {
      "input": function input($event) {
        return _vm.loadReconciliation('user');
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(data) {
        return [_c('UserSelect', {
          attrs: {
            "user": data
          }
        })];
      }
    }], null, false, 3839851139),
    model: {
      value: _vm.selectEmpId,
      callback: function callback($$v) {
        _vm.selectEmpId = $$v;
      },
      expression: "selectEmpId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.filterDivisionIdOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Select Division"
    },
    on: {
      "input": function input($event) {
        return _vm.loadReconciliation('division');
      }
    },
    model: {
      value: _vm.selectDivisionId,
      callback: function callback($$v) {
        _vm.selectDivisionId = $$v;
      },
      expression: "selectDivisionId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.filterDepartmentIdOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Select Department"
    },
    on: {
      "input": function input($event) {
        return _vm.loadReconciliation('department');
      }
    },
    model: {
      value: _vm.selectDepartmentId,
      callback: function callback($$v) {
        _vm.selectDepartmentId = $$v;
      },
      expression: "selectDepartmentId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.filterStatusOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Select Status"
    },
    on: {
      "input": function input($event) {
        return _vm.loadReconciliation('status');
      }
    },
    model: {
      value: _vm.selectStatus,
      callback: function callback($$v) {
        _vm.selectStatus = $$v;
      },
      expression: "selectStatus"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('v-select', {
    staticClass: "mb-1 custom-font",
    attrs: {
      "options": _vm.filterEmpTypeIdOption,
      "reduce": function reduce(item) {
        return item.id;
      },
      "label": "name",
      "placeholder": "Select Employee Types"
    },
    on: {
      "input": function input($event) {
        return _vm.loadReconciliation('empType');
      }
    },
    model: {
      value: _vm.selectEmpTypeId,
      callback: function callback($$v) {
        _vm.selectEmpTypeId = $$v;
      },
      expression: "selectEmpTypeId"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "2",
      "lg": "4",
      "xs": "12"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Select Date Range",
      "config": {
        mode: 'range'
      }
    },
    on: {
      "input": function input($event) {
        return _vm.loadReconciliation('date');
      }
    },
    model: {
      value: _vm.filterRangeDate,
      callback: function callback($$v) {
        _vm.filterRangeDate = $$v;
      },
      expression: "filterRangeDate"
    }
  })], 1)], 1)], 1)])])] : _vm._e(), _c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_vm.$permissionAbility(_vm.VISIT_ATTENDANCE_APPLY_ALL, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.showApplyModal('apply-employee');
      }
    }
  }, [_vm._v(" Apply For Employee ")])] : [_vm.$permissionAbility(_vm.VISIT_ATTENDANCE_APPLY, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 ml-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.showApplyModal
    }
  }, [_vm._v(" Apply ")])] : _vm._e()]], 2)]), _c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table table-custom-style condensed striped",
      "mode": "remote",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'requested_date',
          type: 'desc'
        }]
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row2, _props$row2$user, _props$row3, _props$row4, _props$row5, _props$row6, _props$row7, _props$row8, _props$row9, _props$row10, _props$row11, _props$row12, _props$row13, _props$row14, _props$row15, _props$row16, _props$row17, _props$row18, _props$row19, _props$row21, _props$row22;
        return [props.column.field === 'name' ? _c('span', [(_props$row = props.row) !== null && _props$row !== void 0 && _props$row.user_id ? [_c('span', {
          staticClass: "cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.onShowPage(props.row.id);
            }
          }
        }, [_c('UserCard', {
          attrs: {
            "user": props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : (_props$row2$user = _props$row2.user) === null || _props$row2$user === void 0 ? void 0 : _props$row2$user.data
          }
        })], 1)] : _vm._e()], 2) : _vm._e(), props.column.field === 'format_company' ? [_c('p', [_vm._v(" Company: "), _c('b', [_vm._v(_vm._s((_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.company))])]), _c('p', [_vm._v(" Contact Person: "), _c('b', [_vm._v(_vm._s((_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.contact_person))])])] : _vm._e(), props.column.field === 'format_requested_time' ? [(_props$row5 = props.row) !== null && _props$row5 !== void 0 && _props$row5.start_time ? [_c('div', [_c('span', [_vm._v(" Check In : "), _c('b', [_vm._v(_vm._s(_vm.formatFnTableCheckIn((_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : _props$row6.start_time)))])])])] : _vm._e(), (_props$row7 = props.row) !== null && _props$row7 !== void 0 && _props$row7.end_time ? [_c('div', [_c('span', [_vm._v(" Check Out : "), _c('b', [_vm._v(_vm._s(_vm.formatFnTableCheckIn((_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : _props$row8.end_time)))])])])] : _vm._e(), (_props$row9 = props.row) !== null && _props$row9 !== void 0 && _props$row9.start_time && (_props$row10 = props.row) !== null && _props$row10 !== void 0 && _props$row10.end_time ? [_c('div', [_c('span', [_vm._v(" Request for: "), _c('b', [_c('b-badge', {
          attrs: {
            "variant": "light-success"
          }
        }, [_vm._v(" " + _vm._s(_vm.formatTimeDff((_props$row11 = props.row) === null || _props$row11 === void 0 ? void 0 : _props$row11.start_time, (_props$row12 = props.row) === null || _props$row12 === void 0 ? void 0 : _props$row12.end_time)) + " Hours ")])], 1)])])] : _vm._e(), [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }, {
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-icon",
          attrs: {
            "variant": "outline-primary",
            "title": (_props$row13 = props.row) === null || _props$row13 === void 0 ? void 0 : _props$row13.description
          }
        }, [_c('feather-icon', {
          staticClass: "btn-icon",
          attrs: {
            "icon": "InfoIcon"
          }
        })], 1)]] : _vm._e(), props.column.field === 'format_status' ? _c('span', [_c('b-badge', {
          attrs: {
            "variant": _vm.statusVariant((_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : _props$row14.status)
          }
        }, [((_props$row15 = props.row) === null || _props$row15 === void 0 ? void 0 : _props$row15.status) === '' ? _c('span', [_vm._v(" Pending ")]) : _c('span', [_vm._v(" " + _vm._s((_props$row16 = props.row) === null || _props$row16 === void 0 ? void 0 : _props$row16.status.toUpperCase()) + " ")])]), _c('br'), ((_props$row17 = props.row) === null || _props$row17 === void 0 ? void 0 : _props$row17.status) !== 'pending' ? [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }, {
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-icon mt-1",
          attrs: {
            "variant": ((_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : _props$row18.status) === 'approved' ? 'outline-success' : 'outline-danger',
            "title": (_props$row19 = props.row) === null || _props$row19 === void 0 ? void 0 : _props$row19.remarks
          }
        }, [_c('feather-icon', {
          staticClass: "btn-icon",
          attrs: {
            "icon": "InfoIcon"
          }
        })], 1)] : _vm._e()], 2) : _vm._e(), props.column.field === 'format_description' ? _c('span', [[_c('b-button', {
          directives: [{
            name: "ripple",
            rawName: "v-ripple.400",
            value: 'rgba(113, 102, 240, 0.15)',
            expression: "'rgba(113, 102, 240, 0.15)'",
            modifiers: {
              "400": true
            }
          }],
          staticClass: "btn-icon",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              var _props$row20;
              return _vm.showDescription((_props$row20 = props.row) === null || _props$row20 === void 0 ? void 0 : _props$row20.description);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "InfoIcon"
          }
        })], 1)]], 2) : _vm._e(), props.column.field === 'action' ? _c('span', [_c('span', {
          on: {
            "click": function click($event) {
              return _vm.onOpenInNewTab(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "EyeIcon",
            "title": "View",
            "size": "16"
          }
        })], 1), (((_props$row21 = props.row) === null || _props$row21 === void 0 ? void 0 : _props$row21.visiting_completed) === 1 || _vm.$permissionAbility(_vm.VISIT_ATTENDANCE_APPROVE_REJECT_SPECIAL, _vm.permissions)) && (props === null || props === void 0 ? void 0 : (_props$row22 = props.row) === null || _props$row22 === void 0 ? void 0 : _props$row22.status) === 'pending' ? [_vm.checkApprovePermission(props.row) ? _c('span', {
          on: {
            "click": function click($event) {
              return _vm.onApprove(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "CheckIcon",
            "title": "Approve",
            "size": "16"
          }
        })], 1) : _vm._e(), _vm.checkRejectPermission(props.row) ? _c('span', {
          on: {
            "click": function click($event) {
              return _vm.rejectModalOpen(props.row);
            }
          }
        }, [_c('feather-icon', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-50 custom-icon cursor-pointer",
          attrs: {
            "icon": "XIcon",
            "title": "Reject",
            "size": "16"
          }
        })], 1) : _vm._e()] : _vm._e()], 2) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-apply-form",
      "centered": "",
      "title": _vm.modelType == 'editModel' ? 'Visit Attendance Details' : 'Visit Attendance Request',
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenApplyModal
    }
  }, [_c('validation-observer', {
    ref: "applyValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.applyFromSubmit($event);
      }
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm$userData = _vm.userData) !== null && _vm$userData !== void 0 && _vm$userData.user_id ? [_c('b-avatar', {
    attrs: {
      "default": "''",
      "src": ((_vm$userData2 = _vm.userData) === null || _vm$userData2 === void 0 ? void 0 : (_vm$userData2$user = _vm$userData2.user) === null || _vm$userData2$user === void 0 ? void 0 : (_vm$userData2$user$da = _vm$userData2$user.data) === null || _vm$userData2$user$da === void 0 ? void 0 : _vm$userData2$user$da.avatar) === '' ? '/avatar.svg' : (_vm$userData3 = _vm.userData) === null || _vm$userData3 === void 0 ? void 0 : (_vm$userData3$user = _vm$userData3.user) === null || _vm$userData3$user === void 0 ? void 0 : (_vm$userData3$user$da = _vm$userData3$user.data) === null || _vm$userData3$user$da === void 0 ? void 0 : _vm$userData3$user$da.avatar
    }
  }), _c('h4', [_vm._v(" " + _vm._s((_vm$userData4 = _vm.userData) === null || _vm$userData4 === void 0 ? void 0 : (_vm$userData4$user = _vm$userData4.user) === null || _vm$userData4$user === void 0 ? void 0 : (_vm$userData4$user$da = _vm$userData4$user.data) === null || _vm$userData4$user$da === void 0 ? void 0 : _vm$userData4$user$da.name) + " "), _c('b-badge', {
    attrs: {
      "variant": "light-secondary"
    }
  }, [_vm._v(_vm._s((_vm$userData5 = _vm.userData) === null || _vm$userData5 === void 0 ? void 0 : (_vm$userData5$user = _vm$userData5.user) === null || _vm$userData5$user === void 0 ? void 0 : (_vm$userData5$user$da = _vm$userData5$user.data) === null || _vm$userData5$user$da === void 0 ? void 0 : _vm$userData5$user$da.employee_number))])], 1), _c('a', {
    staticClass: "font-small-2 font-weight-bold",
    attrs: {
      "href": 'mailto:' + (((_vm$userData6 = _vm.userData) === null || _vm$userData6 === void 0 ? void 0 : (_vm$userData6$user = _vm$userData6.user) === null || _vm$userData6$user === void 0 ? void 0 : (_vm$userData6$user$da = _vm$userData6$user.data) === null || _vm$userData6$user$da === void 0 ? void 0 : _vm$userData6$user$da.email) || '')
    }
  }, [_vm._v(" " + _vm._s((_vm$userData7 = _vm.userData) === null || _vm$userData7 === void 0 ? void 0 : (_vm$userData7$user = _vm$userData7.user) === null || _vm$userData7$user === void 0 ? void 0 : (_vm$userData7$user$da = _vm$userData7$user.data) === null || _vm$userData7$user$da === void 0 ? void 0 : _vm$userData7$user$da.email) + " ")]), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData8 = _vm.userData) === null || _vm$userData8 === void 0 ? void 0 : (_vm$userData8$user = _vm$userData8.user) === null || _vm$userData8$user === void 0 ? void 0 : (_vm$userData8$user$da = _vm$userData8$user.data) === null || _vm$userData8$user$da === void 0 ? void 0 : (_vm$userData8$user$da2 = _vm$userData8$user$da.department) === null || _vm$userData8$user$da2 === void 0 ? void 0 : _vm$userData8$user$da2.name) + " ")]), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData9 = _vm.userData) === null || _vm$userData9 === void 0 ? void 0 : (_vm$userData9$user = _vm$userData9.user) === null || _vm$userData9$user === void 0 ? void 0 : (_vm$userData9$user$da = _vm$userData9$user.data) === null || _vm$userData9$user$da === void 0 ? void 0 : (_vm$userData9$user$da2 = _vm$userData9$user$da.designation) === null || _vm$userData9$user$da2 === void 0 ? void 0 : _vm$userData9$user$da2.name) + " ")])] : _vm._e()], 2)])], 1), _vm.applyEmployee ? [_c('b-form-group', {
    attrs: {
      "label": "Employee",
      "label-for": "user-id"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "employee",
      "vid": "user_id",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          attrs: {
            "id": "user-id",
            "placeholder": "Select Employee",
            "options": _vm.userIdOption,
            "reduce": function reduce(country) {
              return country.id;
            },
            "label": "name"
          },
          on: {
            "input": function input($event) {}
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function fn(data) {
              return [_c('UserSelect', {
                attrs: {
                  "user": data
                }
              })];
            }
          }], null, true),
          model: {
            value: _vm.selectUserId,
            callback: function callback($$v) {
              _vm.selectUserId = $$v;
            },
            expression: "selectUserId"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 2514722231)
  })], 1)] : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Visit Attendance Date*"
    }
  }, [_c('ValidationProvider', {
    attrs: {
      "name": "date",
      "vid": "requested_date",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "placeholder": "Select Date",
            "state": errors.length > 0 ? false : null,
            "id": "attendance-date",
            "disabled": _vm.applyEmployee && !_vm.selectUserId || _vm.modelType === 'editModel',
            "config": _vm.attendanceDateConfig
          },
          model: {
            value: _vm.attendanceDate,
            callback: function callback($$v) {
              _vm.attendanceDate = $$v;
            },
            expression: "attendanceDate"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Requested Check In*"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "check in",
      "vid": "check_in",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "name": "check-in",
            "id": "check_in",
            "placeholder": "09:00 AM",
            "config": {
              enableTime: true,
              noCalendar: true,
              static: true,
              dateFormat: 'H:i:S',
              altInput: true,
              altFormat: 'h:i K',
              minuteIncrement: 1
            },
            "disabled": !_vm.attendanceDate || _vm.modelType === 'editModel',
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.checkIn,
            callback: function callback($$v) {
              _vm.checkIn = $$v;
            },
            expression: "checkIn"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Requested Check Out*"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "check out",
      "vid": "check_out",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "name": "check-out",
            "id": "check_out",
            "placeholder": "06:00 PM",
            "config": {
              enableTime: true,
              noCalendar: true,
              static: true,
              dateFormat: 'H:i:S',
              altInput: true,
              altFormat: 'h:i K',
              minuteIncrement: 1
            },
            "disabled": !_vm.attendanceDate || _vm.modelType === 'editModel',
            "state": errors.length > 0 ? false : null
          },
          model: {
            value: _vm.checkOut,
            callback: function callback($$v) {
              _vm.checkOut = $$v;
            },
            expression: "checkOut"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-form-group', {
    attrs: {
      "label": "Description*",
      "label-for": "description"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "description",
      "vid": "description",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "description",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Description",
            "rows": "3",
            "disabled": _vm.modelType === 'editModel'
          },
          model: {
            value: _vm.description,
            callback: function callback($$v) {
              _vm.description = $$v;
            },
            expression: "description"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Contact Person",
      "label-for": "contact_person"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "contact person",
      "vid": "contact_person",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "contact_person",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Contact Person",
            "disabled": _vm.modelType === 'editModel'
          },
          model: {
            value: _vm.contact_person,
            callback: function callback($$v) {
              _vm.contact_person = $$v;
            },
            expression: "contact_person"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    staticClass: "required-label",
    attrs: {
      "label": "Company",
      "label-for": "company"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "company",
      "vid": "company",
      "rules": "required|max:255"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var errors = _ref7.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "company",
            "type": "text",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Enter Company",
            "disabled": _vm.modelType === 'editModel'
          },
          model: {
            value: _vm.company,
            callback: function callback($$v) {
              _vm.company = $$v;
            },
            expression: "company"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Address*",
      "label-for": "address"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "address",
      "vid": "address",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var errors = _ref8.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "address",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Address",
            "rows": "3",
            "disabled": _vm.modelType === 'editModel'
          },
          model: {
            value: _vm.address,
            callback: function callback($$v) {
              _vm.address = $$v;
            },
            expression: "address"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), _vm.modelType == 'editModel' ? [_c('b-form-group', {
    class: _vm.checkApprovePermission(_vm.userData) ? 'required-label' : '',
    attrs: {
      "label": "Remarks",
      "label-for": "remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "remarks",
      "vid": "remarks",
      "rules": _vm.checkApprovePermission(_vm.userData) ? 'required' : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref9) {
        var errors = _ref9.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "required-remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Remarks",
            "rows": "3",
            "disabled": !_vm.checkApprovePermission(_vm.userData)
          },
          model: {
            value: _vm.remarks,
            callback: function callback($$v) {
              _vm.remarks = $$v;
            },
            expression: "remarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }], null, false, 611707180)
  })], 1)] : _vm._e(), _vm.isApplyFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : _vm._e(), !_vm.approveButton && !_vm.isApplyFormSubmitLoading ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])] : _vm._e(), _vm.approveButton && !_vm.isApplyFormSubmitLoading ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.handleApproveClick
    }
  }, [_vm._v(" Approve ")])] : _vm._e()], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-reject-form",
      "centered": "",
      "title": "Reject Request",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.hiddenRejectModal
    }
  }, [_c('validation-observer', {
    ref: "rejectValidation"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.rejectFromSubmit($event);
      }
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(_vm$userData10 = _vm.userData) !== null && _vm$userData10 !== void 0 && _vm$userData10.user_id ? [_c('b-avatar', {
    attrs: {
      "default": "''",
      "src": ((_vm$userData11 = _vm.userData) === null || _vm$userData11 === void 0 ? void 0 : (_vm$userData11$user = _vm$userData11.user) === null || _vm$userData11$user === void 0 ? void 0 : (_vm$userData11$user$d = _vm$userData11$user.data) === null || _vm$userData11$user$d === void 0 ? void 0 : _vm$userData11$user$d.avatar) === '' ? '/avatar.svg' : (_vm$userData12 = _vm.userData) === null || _vm$userData12 === void 0 ? void 0 : (_vm$userData12$user = _vm$userData12.user) === null || _vm$userData12$user === void 0 ? void 0 : (_vm$userData12$user$d = _vm$userData12$user.data) === null || _vm$userData12$user$d === void 0 ? void 0 : _vm$userData12$user$d.avatar
    }
  }), _c('h4', [_vm._v(" " + _vm._s((_vm$userData13 = _vm.userData) === null || _vm$userData13 === void 0 ? void 0 : (_vm$userData13$user = _vm$userData13.user) === null || _vm$userData13$user === void 0 ? void 0 : (_vm$userData13$user$d = _vm$userData13$user.data) === null || _vm$userData13$user$d === void 0 ? void 0 : _vm$userData13$user$d.name) + " "), _c('b-badge', {
    attrs: {
      "variant": "light-secondary"
    }
  }, [_vm._v(_vm._s((_vm$userData14 = _vm.userData) === null || _vm$userData14 === void 0 ? void 0 : (_vm$userData14$user = _vm$userData14.user) === null || _vm$userData14$user === void 0 ? void 0 : (_vm$userData14$user$d = _vm$userData14$user.data) === null || _vm$userData14$user$d === void 0 ? void 0 : _vm$userData14$user$d.employee_number))])], 1), _c('a', {
    staticClass: "font-small-2 font-weight-bold",
    attrs: {
      "href": 'mailto:' + (((_vm$userData15 = _vm.userData) === null || _vm$userData15 === void 0 ? void 0 : (_vm$userData15$user = _vm$userData15.user) === null || _vm$userData15$user === void 0 ? void 0 : (_vm$userData15$user$d = _vm$userData15$user.data) === null || _vm$userData15$user$d === void 0 ? void 0 : _vm$userData15$user$d.email) || '')
    }
  }, [_vm._v(" " + _vm._s((_vm$userData16 = _vm.userData) === null || _vm$userData16 === void 0 ? void 0 : (_vm$userData16$user = _vm$userData16.user) === null || _vm$userData16$user === void 0 ? void 0 : (_vm$userData16$user$d = _vm$userData16$user.data) === null || _vm$userData16$user$d === void 0 ? void 0 : _vm$userData16$user$d.email) + " ")]), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData17 = _vm.userData) === null || _vm$userData17 === void 0 ? void 0 : (_vm$userData17$user = _vm$userData17.user) === null || _vm$userData17$user === void 0 ? void 0 : (_vm$userData17$user$d = _vm$userData17$user.data) === null || _vm$userData17$user$d === void 0 ? void 0 : (_vm$userData17$user$d2 = _vm$userData17$user$d.department) === null || _vm$userData17$user$d2 === void 0 ? void 0 : _vm$userData17$user$d2.name) + " ")]), _c('br'), _c('b-badge', {
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" " + _vm._s((_vm$userData18 = _vm.userData) === null || _vm$userData18 === void 0 ? void 0 : (_vm$userData18$user = _vm$userData18.user) === null || _vm$userData18$user === void 0 ? void 0 : (_vm$userData18$user$d = _vm$userData18$user.data) === null || _vm$userData18$user$d === void 0 ? void 0 : (_vm$userData18$user$d2 = _vm$userData18$user$d.designation) === null || _vm$userData18$user$d2 === void 0 ? void 0 : _vm$userData18$user$d2.name) + " ")])] : _vm._e()], 2)])], 1), _c('b-form-group', {
    attrs: {
      "label": "Rejection Remarks*",
      "label-for": "rejection_remarks"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Rejection Remarks",
      "vid": "rejection_remarks",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref10) {
        var errors = _ref10.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "rejection_remarks",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Rejection Remarks",
            "rows": "3"
          },
          model: {
            value: _vm.rejectionRemarks,
            callback: function callback($$v) {
              _vm.rejectionRemarks = $$v;
            },
            expression: "rejectionRemarks"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1), [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1), [_c('b-modal', {
    attrs: {
      "id": "modal-description-view",
      "centered": "",
      "title": _vm.isPopUpDescription ? 'Description' : 'Remarks',
      "hide-footer": "",
      "no-close-on-backdrop": ""
    },
    on: {
      "hidden": _vm.hiddenDescriptionModal
    }
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")])]], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }